export function Home() {
  // minimal welcome page per request
  return (
    <div className="min-h-screen grid place-items-center p-6">
      <h1 className="text-4xl font-bold tracking-tight">Welcome to Stardeck</h1>
    </div>
  );
}
